import { COMMON_FORM_FIELDS, FormConfig } from '../../models/dynamic.model';
import { TableColumnsProp } from '../../models/tables.model';

const isSelectedAndDefaultView = {
  defaultView: true,
  isSelected: true,
};

const LABELS = {
  AGENT: 'Agent',
  INVOICE_NUMBER: 'Invoice Number',
  INVOICE_DATE: 'Invoice Date',
  CHARGE_CODE: 'Agent Charge Code',
  ORIGINAL_CHARGE_CURRENCY: 'Original Charge Currency',
  CHARGE_CURRENCY: 'Charge Currency',
  CHARGE_AMOUNT_INCOMING: 'Charge Amount (Incoming)',
  CHARGE_AMOUNT: 'Charge Amount',
  CHARGE_AMOUNT_DOLLAR: 'Charge Amount ($)',
  CHARGE_AMOUNT_ORIGINAL: 'Charge Amount (Original)',
  CONVERSION_RATE: 'Conversion Rate',
  WEIGHT: 'Weight',
  SHIPMENT_ID: 'Shipment ID',
  AR_INVOICE_NUMBER: 'AR Invoice Number',
};

export const apChargesTableConfig: TableColumnsProp[] = [
  {
    label: LABELS.AGENT,
    ...isSelectedAndDefaultView,
    key: 'agentId',
    defaultPrintWidth: 150,
  },
  {
    label: LABELS.INVOICE_NUMBER,
    key: 'invoiceNumber',
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 150,
  },
  {
    ...isSelectedAndDefaultView,
    key: 'invoiceDate',
    label: LABELS.INVOICE_DATE,
    defaultPrintWidth: 120,
  },
  {
    label: LABELS.CHARGE_CODE,
    ...isSelectedAndDefaultView,
    key: 'agentChargeCode',
    defaultPrintWidth: 130,
  },
  {
    label: LABELS.ORIGINAL_CHARGE_CURRENCY,
    ...isSelectedAndDefaultView,
    key: 'incomingChargeCurrency',
    defaultPrintWidth: 150,
  },
  {
    key: 'incomingChargeAmount',
    ...isSelectedAndDefaultView,
    label: LABELS.CHARGE_AMOUNT_INCOMING,
    defaultPrintWidth: 150,
  },
  {
    label: LABELS.CHARGE_AMOUNT_DOLLAR,
    key: 'chargeAmount',
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 150,
  },
  {
    label: LABELS.CONVERSION_RATE,
    key: 'conversionRate',
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 120,
  },
  {
    label: LABELS.WEIGHT,
    key: 'weight',
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 80,
  },
  {
    label: LABELS.SHIPMENT_ID,
    key: 'shipmentIdentifierValue',
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 150,
  },
  {
    label: LABELS.AR_INVOICE_NUMBER,
    key: 'arInvoiceNumber',
    ...isSelectedAndDefaultView,
    defaultPrintWidth: 150,
  },
];
// SPEC-APL-001 AC-APL-001: Shipment AP grid leads with Invoice Number, Invoice Date, Agent.
const shipmentApChargesLeadingKeys = [
  'invoiceNumber',
  'invoiceDate',
  'arInvoiceNumber',
  'agentId',
];

export const shipmentApChargesTableConfig: TableColumnsProp[] = [
  ...shipmentApChargesLeadingKeys.flatMap(key =>
    apChargesTableConfig.filter(column => column.key === key)
  ),
  ...apChargesTableConfig.filter(
    column => !shipmentApChargesLeadingKeys.includes(column.key)
  ),
];

export const apInvoiceNumberAutocompleteKey = 'invoiceNumber';

export const numericFields = [
  'incomingChargeAmount',
  'chargeAmount',
  'conversionRate',
  'weight',
];

export const apChargeCodeFormConfig: FormConfig = {
  fields: [
    {
      id: 'apInvoiceId',
      type: 'extra',
    },
    {
      id: 'invoiceChargesId',
      type: 'extra',
    },
    {
      id: 'shipmentIdentifierId',
      type: 'extra',
    },
    {
      id: 'agentChargeCodeId',
      type: 'extra',
    },
    {
      id: 'destinationId',
      type: 'extra',
    },
    {
      id: 'incomingChargeCurrencyId',
      type: 'extra',
    },
    COMMON_FORM_FIELDS.isRowDisable,
    {
      id: 'isLocked',
      type: 'extra',
    },
    {
      id: 'tempId',
      type: 'extra',
    },
    {
      id: 'agent',
      type: 'extra',
    },
    COMMON_FORM_FIELDS.action,
    {
      id: 'agentChargeCodeDescription',
      type: 'extra',
    },
    {
      id: 'shipmentId',
      type: 'extra',
    },
    {
      id: 'agentId',
      type: 'input',
      label: LABELS.AGENT,
    },
    {
      id: 'invoiceNumber',
      type: 'input',
      label: LABELS.INVOICE_NUMBER,
      requiredError: 'Invoice Number is required',
      maxValue: 126,
      allowAlphaNumeric: true,
    },
    {
      id: 'invoiceDate',
      type: 'input',
      label: LABELS.INVOICE_DATE,
    },
    {
      id: 'agentChargeCode',
      type: 'input',
      label: LABELS.CHARGE_CODE,
    },
    {
      id: 'incomingChargeCurrency',
      type: 'input',
      label: LABELS.CHARGE_CURRENCY,
    },
    {
      id: 'incomingChargeAmount',
      type: 'input',
      label: LABELS.CHARGE_AMOUNT,
      allowNumericWithDecimal: true,
      maxValue: 13,
      required: true,
      requiredError: 'Charge Amount is required',
    },
    {
      id: 'chargeAmount',
      type: 'input',
      label: LABELS.CHARGE_AMOUNT_ORIGINAL,
    },
    {
      id: 'conversionRate',
      type: 'input',
      label: LABELS.CONVERSION_RATE,
    },
    {
      id: 'arInvoiceNumber',
      type: 'input',
      label: LABELS.AR_INVOICE_NUMBER,
    },
    {
      id: 'weight',
      type: 'extra',
    },
    {
      id: 'shipmentIdentifierValue',
      type: 'extra',
    },
  ],
};
